var React = require('react');

function CircleChecked (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M44.5002 79.1092C21.9715 79.1092 3.7085 62.17 3.7085 41.2743C3.7085 20.3787 21.9715 3.43945 44.5002 3.43945C67.0288 3.43945 85.2918 20.3787 85.2918 41.2743C85.2918 62.17 67.0288 79.1092 44.5002 79.1092ZM44.5002 72.2301C62.9327 72.2301 77.8752 58.3708 77.8752 41.2743C77.8752 24.1779 62.9327 10.3185 44.5002 10.3185C26.0677 10.3185 11.1252 24.1779 11.1252 41.2743C11.1252 58.3708 26.0677 72.2301 44.5002 72.2301ZM56.7113 28.5238L37.0835 46.7289L28.5807 38.8424L23.3363 43.7066L37.0835 56.4574L61.9557 33.388L56.7113 28.5238Z","fill":"#147144"}));
}

CircleChecked.defaultProps = {"width":"89","height":"83","viewBox":"0 0 89 83","fill":"none"};

module.exports = CircleChecked;

CircleChecked.default = CircleChecked;
